import { API } from "aws-amplify";
import { getUser, listLeases } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import * as APITypes from "~/API";
import { getGraphqlFilters } from "~/utils";

// TODO [Translate]

export const getPropertyManagerByTenantID = async (
  tenantID: string
): Promise<LoaderData<APITypes.User | null>> => {
  let filters: GRAPHQLFilters = getGraphqlFilters({
    tenantID,
    status: APITypes.LeaseStatusType.Active,
  });
  try {
    // Find the current user's lease to find out who their property manager is
    const leaseResponse = (await API.graphql({
      query: listLeases,
      variables: {
        filter: filters,
      },
    })) as { data?: APITypes.ListLeasesQuery };

    if (
      !leaseResponse.data?.listLeases?.items ||
      leaseResponse.data.listLeases.items.length <= 0
    ) {
      throw new Error("No active lease found"); // TODO [Translate]
    }

    const propertyManagerResponse = (await API.graphql({
      query: getUser,
      variables: {
        id: leaseResponse.data.listLeases.items[0]?.userID,
      },
    })) as { data?: APITypes.GetUserQuery };

    return {
      success: true,
      data: propertyManagerResponse.data?.getUser ?? null,
    };
  } catch (error: any) {
    // TODO Fix error message publish rate
    // message.error(error.message);
    console.error("get property manager by tenant id", error);
    return {
      success: false,
      data: null,
      error,
    };
  }
};
